import { render, staticRenderFns } from "./contactDetail.vue?vue&type=template&id=eff6f712&scoped=true&"
import script from "./contactDetail.vue?vue&type=script&lang=ts&"
export * from "./contactDetail.vue?vue&type=script&lang=ts&"
import style0 from "./contactDetail.vue?vue&type=style&index=0&id=eff6f712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff6f712",
  null
  
)

export default component.exports